import React from "react";

/**
 * GameGrid
 * Props:
 *  - wordLength
 *  - maxGuesses
 *  - guesses: array of { letters: string[], results: string[] } (past guesses)
 *  - current: string (current typing row)
 *  - shakeRow: bool (shake the current row)
 *  - revealRow: number | null (row index to animate the flip)
 */
export default function GameGrid({ wordLength, maxGuesses, guesses, current, shakeRow, revealRow }) {
  const rows = [];
  for (let r = 0; r < maxGuesses; r++) {
    if (r < guesses.length) {
      rows.push({ letters: guesses[r].letters, results: guesses[r].results, filled: true, revealed: r !== revealRow });
    } else if (r === guesses.length) {
      const letters = [];
      for (let i = 0; i < wordLength; i++) {
        letters.push(current[i] || "");
      }
      rows.push({ letters, results: Array(wordLength).fill(""), filled: false, current: true });
    } else {
      rows.push({ letters: Array(wordLength).fill(""), results: Array(wordLength).fill(""), filled: false });
    }
  }

  return (
    <div
      className="mx-auto grid gap-2"
      style={{ maxWidth: `${wordLength * 4.25}rem` }}
      data-testid="game-grid"
    >
      {rows.map((row, rIdx) => (
        <div
          key={rIdx}
          className={`grid gap-2 ${row.current && shakeRow ? "row-shake" : ""}`}
          style={{ gridTemplateColumns: `repeat(${wordLength}, minmax(0, 1fr))` }}
          data-testid={`grid-row-${rIdx}`}
        >
          {row.letters.map((ch, i) => {
            const classes = ["tile"];
            const isRevealRow = rIdx === revealRow;
            if (row.filled) {
              if (isRevealRow) {
                classes.push("reveal");
                classes.push(row.results[i]);
              } else {
                classes.push(row.results[i]);
              }
            } else if (ch) {
              classes.push("filled");
            }
            const styleDelay = isRevealRow ? { animationDelay: `${i * 180}ms` } : {};
            return (
              <div
                key={i}
                className={classes.join(" ")}
                style={styleDelay}
                data-testid={`tile-${rIdx}-${i}`}
              >
                {ch}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
